package dev.danko.roblox_craft_ai.uikit.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.BoxScope
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.onMouseEnter
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.toModifier
import dev.danko.roblox_craft_ai.uikit.theme.toAppPalette
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px

val AppCardStyle = CssStyle.base {
    val palette = colorMode.toAppPalette()
    Modifier
        .backgroundColor(palette.surface)
        .border(1.px, LineStyle.Solid, palette.border)
        .borderRadius(1.cssRem)
        .boxShadow(blurRadius = 1.cssRem, color = palette.surface.toRgb().copy(alpha = 128))
        .padding(1.5.cssRem)
        .transition(
            Transition.of("box-shadow", 200.ms),
            Transition.of("border-color", 200.ms),
            Transition.of("background-color", 200.ms),
            Transition.of("transform", 200.ms)
        )
}

val AppCardHoverStyle = CssStyle.base {
    val palette = colorMode.toAppPalette()
    Modifier
        .boxShadow(blurRadius = 2.cssRem, color = palette.accent.toRgb().copy(alpha = 64))
        .border(1.px, LineStyle.Solid, palette.accent.toRgb().copy(alpha = 102))
}

@Composable
fun AppCard(
    modifier: Modifier = Modifier,
    hoverEnabled: Boolean = true,
    content: @Composable BoxScope.() -> Unit
) {
    var hover by remember { mutableStateOf(false) }

    val baseModifier = AppCardStyle.toModifier()
        .then(if (hover && hoverEnabled) AppCardHoverStyle.toModifier() else Modifier)
        .then(
            if (hoverEnabled) Modifier
                .onMouseEnter { hover = true }
                .onMouseLeave { hover = false }
            else Modifier
        )
        .then(modifier)

    Box(baseModifier, contentAlignment = Alignment.TopStart) {
        content()
    }
}
